var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "open-platform" }, [
    _vm._m(0),
    _c("div", { staticClass: "content flex-center" }, [
      _c("img", {
        staticStyle: { width: "428px", height: "428px" },
        attrs: {
          src: require("@/assets/image/open-platform/bg_rel.png"),
          alt: "敬请期待, 欢迎联系",
        },
      }),
      _c("div", { staticClass: "contact-information flex-between-center" }, [
        _c(
          "div",
          { staticClass: "contact-information_item flex-side-center" },
          [
            _c("img", {
              attrs: {
                src: require("@/assets/image/open-platform/icon_wechat_blue.png"),
                alt: "企业微信",
              },
            }),
            _c("div", [
              _c(
                "p",
                { staticStyle: { color: "#061d44", "font-size": "16px" } },
                [_vm._v(_vm._s(_vm.footer.links[0].value))]
              ),
              _c(
                "p",
                { staticStyle: { color: "#4e5969", "font-size": "14px" } },
                [_vm._v(_vm._s(_vm.footer.links[0].label))]
              ),
            ]),
          ]
        ),
        _c("div", { staticClass: "contact-information_item flex" }, [
          _c("img", {
            attrs: {
              src: require("@/assets/image/open-platform/icon_mail_blue.png"),
              alt: "企业微信",
            },
          }),
          _c("div", [
            _c(
              "p",
              { staticStyle: { color: "#061d44", "font-size": "16px" } },
              [_vm._v(_vm._s(_vm.footer.links[1].value))]
            ),
            _c(
              "p",
              { staticStyle: { color: "#4e5969", "font-size": "14px" } },
              [_vm._v(_vm._s(_vm.footer.links[1].label))]
            ),
          ]),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "banner" }, [
      _c("div", { staticClass: "v-page-center div-center text-center" }, [
        _c("div", { staticClass: "title" }, [
          _vm._v("通过开放平台进行开发对接"),
        ]),
        _c("div", { staticClass: "sub-title" }, [
          _vm._v(
            " 我们的AIGC产品，智能硬件产品和SaaS平台，均可以与您已有的软件平台、信息化系统和存量设备对接。 "
          ),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }